import { useState } from "react";

export type DetailItem = {
  id: string;
  title: string;
  icon: string;
  body: string;
};

type Props = {
  items: DetailItem[];
};

export default function DetailsAccordion({ items }: Props) {
  const [open, setOpen] = useState<string | null>(items[0]?.id ?? null);

  return (
    <ul className="divide-y divide-background-200">
      {items.map((item) => {
        const isOpen = open === item.id;
        return (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : item.id)}
              className="w-full flex items-center justify-between gap-4 py-4 text-left cursor-pointer group"
              aria-expanded={isOpen}
            >
              <span className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-950 group-hover:bg-foreground-950 group-hover:text-background-50 transition-colors">
                  <i className={`${item.icon} text-base`}></i>
                </span>
                <span className="text-sm md:text-base font-medium text-foreground-950">
                  {item.title}
                </span>
              </span>
              <i
                className={`ri-arrow-down-s-line text-xl text-foreground-700 transition-transform duration-300 ${
                  isOpen ? "rotate-180" : "rotate-0"
                }`}
              ></i>
            </button>
            <div
              className={`grid transition-all duration-500 ease-out ${
                isOpen ? "grid-rows-[1fr] opacity-100 pb-5" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="text-sm text-foreground-700 leading-relaxed pl-12 pr-2 whitespace-pre-line">
                  {item.body}
                </p>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}